import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft size={20} className="mr-2" />
              Назад
            </Button>
          </Link>
          <h1 className="font-heading text-xl font-bold text-primary">УСЛОВИЯ</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-foreground mb-8">Условия использования</h2>
        
        <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-lg">
            Используя сервис Skinkosh, вы соглашаетесь с настоящими условиями использования.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">1. Общие положения</h3>
          <p>
            Skinkosh предоставляет услуги по обмену криптовалют. Сервис доступен для 
            пользователей, достигших 18 лет и имеющих право заключать юридически обязывающие соглашения.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">2. Услуги</h3>
          <p>
            Мы предоставляем услуги обмена криптовалют по текущим рыночным курсам с учётом 
            комиссии сервиса. Курсы обмена могут меняться в реальном времени.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">3. Обязанности пользователя</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Предоставлять достоверную информацию</li>
            <li>Использовать сервис только для законных целей</li>
            <li>Не нарушать работу сервиса</li>
            <li>Соблюдать применимое законодательство</li>
            <li>Проверять правильность адресов кошельков</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">4. Ограничения</h3>
          <p>Запрещается использование сервиса для:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Отмывания денег и финансирования терроризма</li>
            <li>Мошенничества и обмана</li>
            <li>Нарушения санкционных режимов</li>
            <li>Любой незаконной деятельности</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">5. Риски</h3>
          <p>
            Криптовалюты являются волатильным активом. Курсы могут значительно меняться. 
            Пользователь самостоятельно несёт риски, связанные с операциями с криптовалютами.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">6. Ответственность</h3>
          <p>
            Мы не несём ответственности за:
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Ошибки в адресах кошельков, указанных пользователем</li>
            <li>Задержки, вызванные сетью блокчейн</li>
            <li>Изменение курсов после создания заявки</li>
            <li>Убытки от колебаний курсов</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">7. Возврат средств</h3>
          <p>
            Возврат средств возможен только в случае технического сбоя на стороне сервиса. 
            После отправки криптовалюты пользователем отмена транзакции невозможна.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">8. Изменение условий</h3>
          <p>
            Мы оставляем за собой право изменять условия использования. Актуальная версия 
            всегда доступна на сайте.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">9. Применимое право</h3>
          <p>
            Настоящие условия регулируются законодательством. Все споры решаются путём переговоров.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">10. Контакты</h3>
          <p>
            По вопросам условий использования: legal@skinkosh.com
          </p>

          <p className="text-sm text-muted-foreground mt-8">
            Последнее обновление: Декабрь 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
